import React, { useCallback, useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import { makeStyles } from '@material-ui/styles';
import LocationIcon from './LocationIcon';
import PropTypes from 'prop-types';


const useStyles = makeStyles(theme => ({
  map: {
    height: '40vh',
    width: '100%'
  }
}));

const DEFAULT_POSITION = {
  center: {
    lat: -41,
    lng: 172,
  },
  zoom: 5
}

const LOC_ZOOM = 12;


/**
 * Filter locations that have null lat/lng values.
 * @param {object[]} arr Array of location objects.
 */
const filter = (arr) => {
  return arr.reduce((acc, loc) => {
    let lat = parseFloat(loc.lat);
    let lng = parseFloat(loc.lng);

    if (!isNaN(lat) && !isNaN(lng)) {
      acc.push({ ...loc, lat, lng });
    }
    return acc;
  }, []);
}


/**
 * Base Map
 */
function BaseMap(props) {
  const classes = useStyles();
  const [gMap, setGMap] = useState(null);
  
  // Filter locations that have null values
  const locations = filter(props.locations);
  
  // Set position
  var position = props.position || DEFAULT_POSITION;

  // Handle location changes and re-bounding the map
  const handleRebound = useCallback(() => {
    if (!gMap || !locations) return;
    const { map, maps } = gMap;

    // Use default positions if no locations.
    if (locations.length === 0) {
      map.setCenter(DEFAULT_POSITION.center);
      map.setZoom(DEFAULT_POSITION.zoom);

    // Change position if only 1 location.
    } else if (locations.length === 1) {
      const loc = locations[0];
      map.setCenter({
        lat: loc.lat,
        lng: loc.lng
      });
      map.setZoom(LOC_ZOOM);

    // Reset bounds for more than 1 location.
    } else {
      const bounds = new maps.LatLngBounds();
      locations.forEach(loc => bounds.extend({ lat: loc.lat, lng: loc.lng }));
      map.fitBounds(bounds);
  
      maps.event.addListenerOnce(map, 'bounds_changed', () => {
        if (map.getZoom() > LOC_ZOOM) map.setZoom(LOC_ZOOM);
      });
    }

  }, [gMap, locations]);


  useEffect(handleRebound, [handleRebound]);


  return (
    <div className={classes.map}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyDFUe7M41gqlkbQh6G4mRXxwl_dxPugjbU" }}
        defaultCenter={position.center}
        defaultZoom={position.zoom}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => setGMap({ map, maps })}
      >
        {locations.map(loc => (
          <LocationIcon
            key={loc.id}
            onClick={loc.onClick ? loc.onClick : null}
            lat={loc.lat}
            lng={loc.lng}
          />
        ))}
      </GoogleMapReact>
    </div>
  );
}

BaseMap.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  position: PropTypes.object
}

export default BaseMap;
